<!--Housing-->
<div class="pt-12">
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "housingSection.title" | translate }}
  </span>
</div>
<!-- Address -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_RISQUE)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.address" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.address"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_RISQUE, hasEndorsementWait4Sign)
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            policyAddressHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_RISQUE, hasEndorsementWait4Sign)
          ) + 'w-full'
        "
        [placeholder]="'housingSection.addressPlaceholder' | translate"
        (ngModelChange)="onPolicyAddressChanged()" />
    </div>
  </div>
</div>
<!-- Complement Address -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_COMP)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.address2" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.addressCompl"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_COMP, hasEndorsementWait4Sign)
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            policyAddressComplementHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_COMP, hasEndorsementWait4Sign)
          ) + 'w-full'
        "
        [ngClass]="policyAddressComplementHasChanged ? 'changed-inputtext' : 'normal-inputtext'"
        [placeholder]="'housingSection.address2Placeholder' | translate"
        (ngModelChange)="onPolicyAddressComplementChanged()" />
    </div>
  </div>
</div>
<!-- Postal Code -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_CODE_POSTAL)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.postalCode" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.postalCode"
        pInputText
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.DECLARATION,
            riskItemInfo.ADR_CODE_POSTAL,
            hasEndorsementWait4Sign
          )
        "
        type="text"
        [ngClass]="
          getInputClass(
            policyZipCodeHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.DECLARATION,
              riskItemInfo.ADR_CODE_POSTAL,
              hasEndorsementWait4Sign
            )
          ) + 'w-full'
        "
        [placeholder]="'housingSection.postalCodePlaceholder' | translate"
        (ngModelChange)="onPolicyZipCodeHasChanged()" />
    </div>
  </div>
</div>
<!-- City -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_VILLE)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.city" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="policyDetailsCopy.city"
        pInputText
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_VILLE, hasEndorsementWait4Sign)
        "
        type="text"
        [ngClass]="
          getInputClass(
            policyCityHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_VILLE, hasEndorsementWait4Sign)
          ) + 'w-full'
        "
        [placeholder]="'housingSection.cityPlaceholder' | translate"
        (ngModelChange)="onPolicyCityChanged()" />
    </div>
  </div>
</div>

<!-- Nature Residence -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NATURE_LOG)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.typeResidence" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="natureResidenceOptions"
        [(ngModel)]="natureLogement"
        appendTo="body"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NATURE_LOG, hasEndorsementWait4Sign)
        "
        [styleClass]="
          getDropdownClass(
            natureResidenceHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NATURE_LOG, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onNatureLogementChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Qualité Occupant -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NATURE_OCCU)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.qualityOccupant" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="qualiteOccupantOptions"
        [(ngModel)]="qualiteOccupant"
        appendTo="body"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NATURE_OCCU, hasEndorsementWait4Sign)
        "
        [styleClass]="
          getDropdownClass(
            qualiteOccupantHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NATURE_OCCU, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onQualiteOccupantChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Type Habitation -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.HAB_TYPE)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.houseType" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [(ngModel)]="typeHabitation"
        pInputText
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.HAB_TYPE, hasEndorsementWait4Sign)
        "
        type="text"
        [ngClass]="
          getInputClass(
            typeHabitationHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.HAB_TYPE, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        [placeholder]="'generalOptions.placeholder' | translate"
        (ngModelChange)="onTypeHabitationChange()" />
    </div>
  </div>
</div>

<!-- Nb de pièces -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NBR_PIECES)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.nbrPieces" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="nombrePiecesOptions"
        [(ngModel)]="nombrePieces"
        appendTo="body"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NBR_PIECES, hasEndorsementWait4Sign)
        "
        [styleClass]="
          getDropdownClass(
            nombrePiecesHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NBR_PIECES, hasEndorsementWait4Sign)
          ) + ' w-full'
        "
        (ngModelChange)="onNombrePiecesChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Nb de pièces 40 -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NBR_PIECES_40M2)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.nbrPieces40" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="nombrePiecesQuaranteOptions"
        [(ngModel)]="nombrePiecesQuarante"
        appendTo="body"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NBR_PIECES, hasEndorsementWait4Sign)
        "
        [styleClass]="
          getDropdownClass(
            nombrePiecesQuaranteHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.NBR_PIECES, hasEndorsementWait4Sign)
          ) + 'w-full'
        "
        (ngModelChange)="onNombrePiecesQuaranteChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Etage -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_ETAGE) &&
    typeHabitation === HouseType.Appartement
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.floorHouse" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="etageOptions"
        [(ngModel)]="etage"
        appendTo="body"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_ETAGE, hasEndorsementWait4Sign)
        "
        [styleClass]="
          getDropdownClass(
            etageHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.ADR_ETAGE, hasEndorsementWait4Sign)
          ) + 'w-full'
        "
        (ngModelChange)="onEtageChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Dependance -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.SURFACE_DEP)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "housingSection.dependance" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="dependanceOptions"
        [(ngModel)]="surfaceDependance"
        appendTo="body"
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.SURFACE_DEP, hasEndorsementWait4Sign)
        "
        [styleClass]="
          getDropdownClass(
            surfaceDependanceHasChanged,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.SURFACE_DEP, hasEndorsementWait4Sign)
          ) + 'w-full'
        "
        (ngModelChange)="onSurfaceDependanceHasChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Piscine -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.POSSEDE_PISCINE) &&
    typeHabitation !== HouseType.Appartement
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "contractDetails.poolOption" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="falseTrueValues"
        [(ngModel)]="possedePiscine"
        appendTo="body"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.DECLARATION,
            riskItemInfo.POSSEDE_PISCINE,
            hasEndorsementWait4Sign
          )
        "
        [styleClass]="
          getDropdownClass(
            possedePiscineHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.DECLARATION,
              riskItemInfo.POSSEDE_PISCINE,
              hasEndorsementWait4Sign
            )
          ) + 'w-full'
        "
        (ngModelChange)="onPossedePiscineChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- Veranda -->
<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.POSSEDE_VERANDA)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "contractDetails.verandaOption" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="falseTrueValues"
        [(ngModel)]="possedeVeranda"
        appendTo="body"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.DECLARATION,
            riskItemInfo.POSSEDE_VERANDA,
            hasEndorsementWait4Sign
          )
        "
        [styleClass]="
          getDropdownClass(
            possedeVerandaHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.DECLARATION,
              riskItemInfo.POSSEDE_VERANDA,
              hasEndorsementWait4Sign
            )
          ) + 'w-full'
        "
        (ngModelChange)="onPossedeVerandaChange()"></p-dropdown>
    </div>
  </div>
</div>

<!-- EnergieV -->
<div
  *ngIf="
    getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, riskItemInfo.POSSEDE_ENERGIEV) &&
    typeHabitation !== HouseType.Appartement
  "
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "contractDetails.renewEnergy" | translate }}
    </span>
  </div>
  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <p-dropdown
        [options]="falseTrueValues"
        [(ngModel)]="possedeEnergieV"
        appendTo="body"
        [disabled]="
          !getIsEditable(
            policyFieldsVM,
            PolicyFields.DECLARATION,
            riskItemInfo.POSSEDE_ENERGIEV,
            hasEndorsementWait4Sign
          )
        "
        [styleClass]="
          getDropdownClass(
            possedeEnergieVHasChanged,
            getIsEditable(
              policyFieldsVM,
              PolicyFields.DECLARATION,
              riskItemInfo.POSSEDE_ENERGIEV,
              hasEndorsementWait4Sign
            )
          ) + 'w-full'
        "
        (ngModelChange)="onPossedeEnergieVChange()"></p-dropdown>
    </div>
  </div>
</div>

